export default "__VITE_ASSET__C5C8yw7k__"